import React, { useEffect, useRef } from "react";
import "./loginComponent.css";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { LoaderContext } from "../../context/LoaderContext";
import { UserContext } from "../../context/UserContext";
import Loader from "../loader/loader";
import { API_URL } from "../../enviormentVariables";
import { Modal } from "../Modals/ModalComponent/Modal";
import ModalDividerLine from "../Modals/ModalComponent/modal-divider-line";
import { AlertContext } from "../../context/AlertContext";
import { Alert, Log } from "../../utils/genericUtils";

function LoginComponent() {
  const router = useNavigate();
  const { show, showloader, hideloader } = useContext(LoaderContext);
  const { user, loginUser } = useContext(UserContext);
  const { globalAlert } = useContext(AlertContext);

  const remember_me_input = useRef();
  const error_message = useRef();

  useEffect(() => {}, []);

  function validateFields() {
    let isValid = true;
    let usernameInput = document.getElementById("username-input");
    let passwordInput = document.getElementById("password-input");

    let userEnteredAnEmail = usernameInput.value.includes("@");
    if (userEnteredAnEmail) {
      if (usernameInput.value.length < 1) {
        isValid = false;
        usernameInput.value = "";
        usernameInput.placeholder = "username or email required";
        usernameInput.style.border = "2px solid red";
      } else {
        // Email validation logic
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(usernameInput.value)) {
          isValid = false;
          usernameInput.value = "";
          usernameInput.placeholder = "invalid email format";
          usernameInput.style.border = "2px solid red";
        }
      }
    } else {
      if (usernameInput.value.length < 1) {
        isValid = false;
        usernameInput.value = "";
        usernameInput.placeholder = "username required";
        usernameInput.style.border = "2px solid red";
      }
    }

    if (passwordInput.value.length < 1) {
      isValid = false;
      passwordInput.value = "";
      passwordInput.placeholder = "password required";
      passwordInput.style.border = "2px solid red";
    }
    return isValid;
  }

  function login() {
    if (validateFields()) {
      showloader();
      let request = new XMLHttpRequest();
      request.open("POST", API_URL + "/login");
      request.setRequestHeader("Content-Type", "application/json");
      //get inputs
      let username = document.getElementById("username-input").value;
      let password = document.getElementById("password-input").value;
      let device_token = localStorage.getItem("device_token") ?? undefined;
      let loginRequest = {
        username,
        password,
        device_token,
      };
      request.send(JSON.stringify(loginRequest));
      request.onload = () => {
        let response = JSON.parse(request.response);

        if (response.mfa_flow) {
          loginUser(response.user);
          router(`/mfa-login?remember=${remember_me_input.current.checked}`);
          return;
        }

        //check for jwt
        if (response.jwt) {
          let remember_me = remember_me_input.current.checked;
          if (remember_me === true) {
            //save to local storage
            localStorage.setItem("jwt", response.jwt);
          } else {
            //save to session storage
            sessionStorage.setItem("jwt", response.jwt);
          }
        }

        if (response.success) {
          loginUser(response.user);
          router("/dashboard");
        } else {
          hideloader();

          if (response.error.code == 300 || response.error.code == 302) {
            error_message.current = response.error.message;
          }

          if (response.error.code == 301) {
            router("/email-verification?id=" + username);
          }
        }
      };
      request.onerror = () => {
        hideloader();
        if (request.status === 0) {
          Alert(globalAlert, "error", "Network Issue", "Connection failed check your internet connection.");
        }
        Log(request.response);
      };
    }
  }

  function ShowErrorMessage() {
    if (error_message.current) {
      return <p className="error-message">*{error_message.current}</p>;
    }
  }

  return (
    <>
      <Loader />
      <Modal id="login-modal" isActive={true} animate={false} header="Login" showDivider={true}>
        <div className="input-box">
          <label className="input-label" htmlFor="username-input">
            Username or Email
          </label>
          <input type="email" id="username-input" placeholder="username" />
        </div>

        <div className="input-box">
          <label className="input-label" htmlFor="password-input">
            Password
          </label>
          <input type="password" id="password-input" placeholder="password" />
        </div>

        {ShowErrorMessage()}

        {/* Forgot Password */}
        <div className="forgot-password-container">
          <div className="remember-me">
            <label htmlFor="">Remember Me</label>
            <input type="checkbox" ref={remember_me_input} />
          </div>

          <Link className="forgot-password" to={"/forgot-password"}>
            Forgot Password
          </Link>
        </div>

        <ModalDividerLine showDivider={true} />

        <button type="button" className="standard-button login-button" onClick={login}>
          Sign In
        </button>

        {/* Sign Up */}
        <div className="already-have-an-account-box">
          <p>Don't have an account?</p>
          <Link className="sign-up-link" to={"/register"}>
            Sign up
          </Link>
        </div>
      </Modal>
    </>
  );
}

export default LoginComponent;
